// Module
export { PhonebookModule } from './phonebook.module';

// Services (inject these in your components)
export { PhonebookService } from './services/phonebook.service';
export { PhonebookSidebarService } from './services/phonebook-sidebar.service';
export { ToastService } from './services/toast.service';

// Models (use these for typing)
export * from './models/phonebook.models';

// Components (rarely needed directly, but available)
export { PhonebookSidebarComponent } from './components/phonebook-sidebar/phonebook-sidebar.component';
export { ContactFormDialogComponent } from './components/contact-form-dialog/contact-form-dialog.component';
export { DeleteConfirmDialogComponent } from './components/delete-confirm-dialog/delete-confirm-dialog.component';
export { ToastComponent } from './components/toast/toast.component';
